import Manager from "../../src/manager";
import React from "react";
import Functions from "../../src/functions";

function Mapper(data, status, response, error, component) {
    let output = [];
    let UserType = Functions["custom"]["getUserType"]();
    if(UserType === 'HYBRID_BUSINESS_COST_CONTROL' || UserType === 'HYBRID_RESIDENTIAL_COST_CONTROL'){
        data = JSON.parse(sessionStorage.getCustomerData);
    }
    if(data){
        let property = {};
        property['bundlesInfoList'] = data.bundlesInfoList;
        property['categoriesInfoList'] = data.categoriesInfoList;
        output.push(property);
    }
    return output;
}

function Properties(args) {
    let editable = args.editable ? true : false;
    return {
        id: {
            alias:"id",
            type:"text",
            editable
        },
        bundlesInfoList: {
            alias:"bundlesInfoList",
            type:"text",
            editable
        },
        categoriesInfoList: {
            alias:"categoriesInfoList",
            type:"text",
            editable
        },
    };
}

const HybridWallet = {
    auth: "",
    views: {
        list: {
            apis: {
                view: {
                    data: [{}],
                    mapper: Mapper,
                },
            },
            template: "hybrid",
            templateConfiguration: {
                includeProperties: [],
                excludeProperties: [],
                events: {onClick: function (e){}},
            },
            properties: Properties({ editable: false }),
            primaryKey: "id",
        },
    },
};

export default HybridWallet;